import id from './id'

const done = {
  field: 'done',
  type: 'boolean',
  datatype: 'int',
  interface: 'switch',
  default_value: 0
}

export default {
  collection: 'data_init',
  note: 'DBの設定です。',
  fields: [
    id,
    done
  ]
}
